import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Grid, Typography, units } from '@hbf/dsl';

import { AboveTheFoldPicture } from 'ha/components.legacy/AboveTheFoldPicture';

const useStyles = makeStyles()({
  wrapper: {
    position: 'relative',
    overflow: 'hidden',
    minHeight: units.rem(26.25),
  },
  textBlock: {
    zIndex: 1,
  },
  title: {
    marginBottom: units.rem(3),
  },
  description: {
    marginBottom: units.rem(4),
    maxWidth: units.rem(42),
  },
});

interface Props {
  title: string;
  description: string;
}

const AboveTheFold: React.FC<Props> = ({ title, description, children }) => {
  const { classes } = useStyles();

  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      className={classes.wrapper}
    >
      <AboveTheFoldPicture />

      <Grid
        container
        item
        direction="column"
        alignItems="center"
        justifyContent="center"
        className={classes.textBlock}
      >
        <Grid item xs="auto">
          <Typography.H1 className={classes.title} noWrap align="center">
            {title}
          </Typography.H1>
        </Grid>

        <Grid item xs="auto" container justifyContent="center">
          <Typography.Paragraph
            className={classes.description}
            color="muted"
            align="center"
          >
            {description}
          </Typography.Paragraph>
        </Grid>

        {children && (
          <Grid item xs="auto">
            {children}
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export { AboveTheFold };
